module.exports = __webpack_public_path__ + "static/media/LTC.207803cc.svg";